import useTranslator from "../../hooks/useTranslator";

const CombinedIncome = ({ combinedIncome, userIncome, gurantorsIncome }) => {
  const { _t } = useTranslator();

  return (
    <div className="mb-3 small-grey-box w-100">
      <div className="score-meter-capsule-wrapper">
        <div className="d-flex justify-content-between align-items-center ">
          <p className="aml-list-item mb-0">{_t("combinedIncome")}</p>
          <p className="orange-note-price">
            €{!Number.isNaN(combinedIncome) ? Math.round(combinedIncome) : 0}
          </p>
        </div>
        <div className="d-flex justify-content-between align-items-center Score-content-list small-grey-box-val">
          <h4 className="">{_t("tenant")}</h4>
          <p className="aml-list-item-p">€{userIncome?.amount ?? 0}</p>
        </div>
        {Array.isArray(gurantorsIncome) &&
          gurantorsIncome.map((item, index) => {
            return (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center Score-content-list  small-grey-box-val"
              >
                <h4 className="">
                  {_t("guarantor")}{" "}
                  {gurantorsIncome.length > 1 ? index + 1 : ""}
                </h4>
                <p className="aml-list-item-p">€{item?.amount}</p>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default CombinedIncome;
